module.exports = __webpack_public_path__ + "static/media/map-marker-vaccination-places-active.76ddbb33.svg";